import api from 'ApiConfig';

const assignmentService = {
  createAssignment: async (data) => {
    return api.post('/teacher/create-assignment', data);
  },
  getAllAssignment: async (data) => {
    return api.post('/teacher/all-assignment', data);
  },
  assignmentByTeacherCourse: async (courseId) => {
    return api.post('/teacher/get-assignment-by-teacher-course', { courseId });
  },
  assignmentToBatches: async (payload) => {
    return api.post('/teacher/assign-assignment', payload);
  },
  createPracticalAssignment: async (data) => {
    return api.post('/teacher/create-practicle-assignmnet', data);
  },
  getAllPracticalAssignments: async (batchId) => {
    return api.post('/teacher/get-practicle-assignmnet', batchId);
  },
  updatePracticalAssignments: async (updatedAssignment) => {
    return api.post('/teacher/update-practicle-assignmnet', updatedAssignment);
  },
  deletePracticalAssignment: async (id) => {
    return api.post('/teacher/delete-practicle-assignmnet', { id });
  },
  assignPracticalAssignmentToStudent: async (data) => {
    return api.post('/teacher/assign-practicle-to-students', data);
  },
  getuploadedAssignments: async (assignmentId) => {
    return api.post('/teacher/teacher-get-uploaded-assignment', {
      assignmentId,
    });
  },
  getCreatedAssignments: async () => {
    return api.post('/teacher/get-created-assignmnet');
  },
  getSubmissionsByAssignmentId: async (AssignmentId) => {
    return api.post('/teacher/get-submission-by-AssignmentId', {
      AssignmentId,
    });
  },
  uploadPdfAssignment: async (formData) => {
    console.log(formData, 'assignmnet service ');
    return api.post('/teacher/upload-pdf-assignment', formData);
  },
};

export default assignmentService;
